import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

const EnrollmentNotAvailable: React.VFC = ({ ...styleProps }) => {
  return (
    <div {...styleProps}>
      <Typography2 component="p">
        {_t(
          'Enrollment for-credit not available at this time. Please try again at the start of the next enrollment period.'
        )}
      </Typography2>
    </div>
  );
};

export default EnrollmentNotAvailable;
